import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, IconButton, InputLabel } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import Flex from '@Components/Bases/Flex';
import { FormTextEditor } from '@Components/Form';
import DeleteModal from '@Components/Modal/DeleteModal';
import { useDisclosure } from '@hooks/useDisclosure';
import { disabledFormInputStyles } from '@Components/Form/styles';

type IntroductionProps = {
  topic: string;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onDelete: () => void;
  fieldPath: string;
  isCompletedTh?: boolean;
  isCompletedEn?: boolean;
};

const Introduction = ({
  topic,
  setOpen,
  fieldPath,
  onDelete,
  isCompletedTh = false,
  isCompletedEn = false,
}: IntroductionProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { resetField, unregister } = useFormContext();

  const handleDelete = () => {
    if (typeof onDelete === 'function') {
      onDelete();
    } else {
      setOpen(false);
    }
    resetField(fieldPath);
    unregister(fieldPath);
  };

  return (
    <>
      <Flex flexDirection={'column'} gap={2} bgcolor={'grey.50'} p={2} pt={1}>
        <Box>
          <Flex justifyContent={'space-between'} sx={{ mb: 0.5 }}>
            <InputLabel>คำบรรยาย {topic} (ไทย)</InputLabel>
            <IconButton
              color="inherit"
              size="small"
              sx={{ padding: 0 }}
              onClick={open}
              disabled={isCompletedTh || isCompletedEn}
            >
              <DeleteOutlineIcon style={{ fontSize: '16px' }} />
            </IconButton>
          </Flex>
          <FormTextEditor
            name={`${fieldPath}.descriptionTh`}
            inputProps={{ placeholder: 'กรุณาระบุคำบรรยาย (ไทย)' }}
            sx={isCompletedTh ? disabledFormInputStyles : {}}
          />
        </Box>
        <FormTextEditor
          name={`${fieldPath}.descriptionEn`}
          label={`คำบรรยาย ${topic} (อังกฤษ)`}
          inputProps={{ placeholder: 'กรุณาระบุคำบรรยาย (อังกฤษ)' }}
          sx={isCompletedEn ? disabledFormInputStyles : {}}
        />
      </Flex>
      <DeleteModal
        topic={`คำบรรยาย ${topic}`}
        opened={opened}
        close={close}
        confirm={handleDelete}
      />
    </>
  );
};

export default Introduction;
